const onResizeCallbacks = [];
const charThatCanBeTrimmed = ',. ;:'.split('');
const DOTS_LENGTH = 3;

$(window).on('resize.textMaxLength', function onResize() {
    onResizeCallbacks.forEach(fn => fn());
});

$.fn.textMaxLength = function textMaxLength(instanceOptions = {}) {
    const $scope = this;
    const defaultOptions = {};

    $scope.each(function eachOfElement(indexOfElement, Element) {
        const $element = $(Element);

        if ($element.data('textMaxLengthInit')) {
            return true;
        }

        $element.data('textMaxLengthInit', true);

        const initialText = $.trim($element.text()).replace(/\n/gi, ' ');
        const elementOptions = {
            adaptive: {
                mobile: parseInt($element.data('text-max-length-mobile')),
                verticalTablet: parseInt($element.data('text-max-length-vertical-tablet')),
                horizontalTablet: parseInt($element.data('text-max-length-horizontal-tablet')),
                desktop: parseInt($element.data('text-max-length-desktop')),
                fullhd: parseInt($element.data('text-max-length-fullhd')),
            },
            reduce: true === $element.data('text-max-length-reduce'),
            trim: true === $element.data('text-max-length-trim'),
        };
        const finalOptions = $.extend(true, {}, defaultOptions, instanceOptions, elementOptions);
        let currentAdaptive;

        if (!finalOptions.adaptive.fullhd) {
            finalOptions.adaptive.fullhd = finalOptions.adaptive.desktop;
        }

        onResize();

        onResizeCallbacks.push(onResize);

        function onResize() {
            const adaptiveName = NLMK.getCurrentAdaptiveName();

            if (adaptiveName === currentAdaptive) {
                return;
            }

            currentAdaptive = adaptiveName;

            let maxTextWidth = finalOptions.adaptive[adaptiveName];

            if (initialText.length > maxTextWidth) {
                maxTextWidth -= DOTS_LENGTH;

                const chars = initialText.split('');
                const finalText = [];

                $.each(chars, function eachChar(index, char) {
                    finalText.push(char);

                    if (index + 1 > maxTextWidth) {
                        if (finalOptions.trim) {
                            finalText.pop();

                            return false;
                        }

                        else if (finalOptions.reduce) {
                            let lastChar;

                            while (!charThatCanBeTrimmed.includes(lastChar)) {
                                lastChar = finalText.pop();
                            }

                            return false;
                        }

                        else if (charThatCanBeTrimmed.includes(char)) {
                            return false;
                        }
                    }
                });

                $element.html(
                    finalText.join('') + $.repeat('.', DOTS_LENGTH)
                );
            }

            else {
                $element.html(initialText);
            }
        }
    });
};

NLMK.textMaxLength = function textMaxLength() {
    $('.js-text-max-length').textMaxLength();
};

$(function ready() {
    NLMK.textMaxLength();
});



// WEBPACK FOOTER //
// ./js/main/plugin/jquery.text-max-length.js